import { useState } from 'react';
import { saveNarrative } from '../../api';

const NARRATIVE_KEYS = [
  { key: 'site_description', label: 'Site Description' },
  { key: 'management_summary', label: 'Management, Communication & Control Summary' },
  { key: 'cold_water_summary', label: 'Mains Cold Water / Cold Water Distribution Summary' },
  { key: 'hot_water_pou_summary', label: 'Combination / POU Water Heater Summary' },
  { key: 'hot_water_storage_summary', label: 'Hot Water Storage Vessels Summary' },
  { key: 'hot_water_distribution_summary', label: 'Hot Water Distribution Summary' },
  { key: 'general_population', label: 'General Population Summary' },
  { key: 'cooling_tower_summary', label: 'Cooling Tower Summary' },
  { key: 'wash_devices_summary', label: 'Wash Devices Summary' },
  { key: 'cutting_devices_summary', label: 'Cutting Devices Summary' },
  { key: 'fire_suppression_summary', label: 'Fire Suppression Summary' },
];

export default function NarrativesTab({ report, sections, onSave, readOnly = false }) {
  const execSection = sections.find((s) => s.code === 'EXEC_SUMMARY');
  const sectionId = execSection?.id || 1;
  const existing = report.narratives || [];

  const getExisting = (key) => existing.find((n) => n.narrativeKey === key);

  const [values, setValues] = useState(() => {
    const v = {};
    NARRATIVE_KEYS.forEach((nk) => {
      const ex = getExisting(nk.key);
      v[nk.key] = { id: ex?.id || null, content: ex?.content || '' };
    });
    return v;
  });
  const [msg, setMsg] = useState('');

  const handleChange = (key, content) => {
    setValues({ ...values, [key]: { ...values[key], content } });
  };

  const handleSave = async (key) => {
    try {
      const result = await saveNarrative(report.id, {
        id: values[key].id,
        sectionId,
        narrativeKey: key,
        content: values[key].content,
        sortOrder: NARRATIVE_KEYS.findIndex((n) => n.key === key),
      });
      setValues({ ...values, [key]: { id: result.id, content: result.content } });
      setMsg(`Saved: ${NARRATIVE_KEYS.find((n) => n.key === key)?.label}`);
      setTimeout(() => setMsg(''), 2000);
    } catch (err) { setMsg(err.message); }
  };

  const [saving, setSaving] = useState(false);

  const handleSaveAll = async () => {
    setSaving(true);
    try {
      for (const nk of NARRATIVE_KEYS) {
        const result = await saveNarrative(report.id, {
          id: values[nk.key].id,
          sectionId,
          narrativeKey: nk.key,
          content: values[nk.key].content,
          sortOrder: NARRATIVE_KEYS.findIndex((n) => n.key === nk.key),
        });
        setValues((prev) => ({ ...prev, [nk.key]: { id: result.id, content: result.content } }));
      }
      setMsg('All narratives saved');
      setTimeout(() => setMsg(''), 2000);
    } catch (err) { setMsg(err.message); }
    finally { setSaving(false); }
  };

  return (
    <div>
      {msg && <div className="alert alert-success">{msg}</div>}
      {!readOnly && (
        <button className="btn btn-primary" onClick={handleSaveAll} disabled={saving} style={{ marginBottom: '1.5rem' }}>
          {saving ? 'Saving...' : 'Save All Narratives'}
        </button>
      )}
      {NARRATIVE_KEYS.map((nk) => (
        <div key={nk.key} className="form-group" style={{ marginBottom: '1.5rem' }}>
          <label>{nk.label}</label>
          <textarea
            rows={4}
            value={values[nk.key]?.content || ''}
            onChange={(e) => handleChange(nk.key, e.target.value)}
            disabled={readOnly}
            style={{ width: '100%', padding: '0.5rem', border: '1px solid #ddd', borderRadius: 6, fontFamily: 'inherit', resize: 'vertical' }}
          />
          {!readOnly && <button className="btn btn-primary" style={{ marginTop: '0.25rem', padding: '0.3rem 0.8rem', fontSize: '0.8rem' }} onClick={() => handleSave(nk.key)}>Save</button>}
        </div>
      ))}
    </div>
  );
}
